module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-15.9ba11f8b.jpg";